// Is this page being served on a customer's own domain (Cloudflare for SaaS → veluro-pages Worker → app)?
const BACKEND_HOST = (() => { try { return new URL(process.env.REACT_APP_BACKEND_URL).hostname; } catch { return ''; } })();

export const isCustomHost = () => {
  const h = (window.location.hostname || '').toLowerCase();
  if (!h || h === 'localhost' || h === BACKEND_HOST) return false;
  if (h.endsWith('.emergentagent.com') || h === 'veluro.ai' || h.endsWith('.veluro.ai')) return false;
  return true;
};

// On a custom host the Worker proxies /api same-origin; everywhere else the configured backend.
export const publicApiBase = () => (isCustomHost() ? window.location.origin : process.env.REACT_APP_BACKEND_URL);
